module.exports = __webpack_public_path__ + "static/media/wait.0aaf3e23.svg";